/**
 * Terms of Service Page
 *
 * Displays the Terms of Service legal document for admeru.
 * Loads the markdown file and renders it with proper formatting.
 */

import React from 'react';
import { LegalDocument } from '../components/legal/LegalDocument';

export const TermsOfServicePage: React.FC = () => {
  return (
    <LegalDocument
      documentPath="/legal/terms-of-service.md"
      title="Terms of Service"
      description="Please read these terms carefully before using admeru. By using our service, you agree to be bound by these terms."
    />
  );
};
